import {AbstractModel} from '../../abstract-model';
import {AvailableDomain} from '../available-domain';
import {FunnelPage} from './funnel-page';

export class Funnel extends AbstractModel {
  id: number | null = null;
  name: string = '';
  domain: AvailableDomain | null = null;
  slug: string | null = null;
  pages: FunnelPage[] = [];
  startPageId: number | null = null;
  enabled = true;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.domain) {
      this.domain = new AvailableDomain().deserialize(input.domain);
    }

    if (input.pages) {
      this.pages = input.pages.map((page: any) => new FunnelPage().deserialize(page));
    }

    return this;
  }

  override toString(): string {
    return this.name;
  }
}
